function NotFound() {
  return (
    <div className="NotFound">
	404 - Page not found.
	</div>
  );
}

export default NotFound;